var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuiweiji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 4",
    clipPath: "url(#clip0_40_2283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631281",
    d: "M5.5 2.5C5.5 1.39543 6.39543 0.5 7.5 0.5C8.60457 0.5 9.5 1.39543 9.5 2.5V10.1544L5.5 7.95436V2.5Z",
    fill: "#8EFF65",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631282",
    d: "M6 5H9V11L6 8.5V5Z",
    fill: "#FF504A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 561",
    d: "M1 10.6667L1.44793 10.0694C3.03393 7.95476 6.1511 7.8012 7.93727 9.74974V9.74974C9.56138 11.5215 12.3349 11.5818 14.0344 9.88223L15 8.91667",
    stroke: "#4A93FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 562",
    d: "M1 14.6667L1.44793 14.0694C3.03393 11.9548 6.1511 11.8012 7.93727 13.7497V13.7497C9.56138 15.5215 12.3349 15.5818 14.0344 13.8822L15 12.9167",
    stroke: "#4A93FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_2283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuiweiji);
export default __webpack_public_path__ + "static/media/shuiweiji.6f6b50c6f2b15e0f2a58d9a1e4bbc24f.svg";
export { ForwardRef as ReactComponent };